const header = document.querySelector(".site-header");
const menuToggle = document.querySelector(".menu-toggle");
const listCount = document.querySelector("#listCount");
const mobileListCount = document.querySelector("#mobileListCount");
const signupForm = document.querySelector(".signup-form");
const formNote = document.querySelector(".form-note");
const progress = document.querySelector(".scroll-progress");
const heroImage = document.querySelector(".hero-image");
const toast = document.querySelector(".toast");
const backToTop = document.querySelector(".back-to-top");
const detailDrawer = document.querySelector(".detail-drawer");
const listDrawer = document.querySelector(".list-drawer");
const selectedItems = document.querySelector("#selectedItems");
const emptyList = document.querySelector(".empty-list");
const selectedSet = document.querySelector("#selectedSet");
const messageField = document.querySelector("#message");
const collectionPanel = document.querySelector("#collectionPanel");
const collectionEyebrow = document.querySelector("#collectionEyebrow");
const collectionTitle = document.querySelector("#collectionTitle");
const collectionCopy = document.querySelector("#collectionCopy");
const collectionProducts = document.querySelector("#collectionProducts");
const prologue = document.querySelector(".prologue");
const replayPrologue = document.querySelector(".replay-prologue");
const siteMusic = document.querySelector("#siteMusic");
const musicToggle = document.querySelector(".music-toggle");

const listState = new Map();
const giftChoices = new Map();
let toastTimer;
let activeDetail = null;
let musicAllowed = localStorage.getItem("yunjianMusicMuted") !== "true";
let musicGestureBound = false;

const collectionData = {
  porcelain: {
    eyebrow: "Porcelain · 瓷器",
    title: "Porcelain for Tea Rituals",
    copy: "Celadon and handmade porcelain pieces for tea tables, first collectibles and quiet gifts.",
    products: [
      {
        name: "Celadon Teacup Gift Set",
        label: "Celadon Teacup Gift Set · $168",
        category: "Porcelain · 瓷器",
        price: "$168",
        material: "Handmade celadon, mineral glaze, collector note card",
        maker: "Porcelain maker profile is shared when available.",
        use: "Tea table gifting, first collectible, study display",
        leadTime: "Usually ready-to-ship after condition check; made-to-order porcelain can require 10-30 days.",
        package: "Rigid gift box, protective insert, English material card",
        ship: "Porcelain pieces receive a second condition check before shipment and ship with reinforced packaging.",
        desc: "A handmade celadon teacup with a collector card, designed as an accessible first piece for overseas gifting."
      },
      {
        name: "Porcelain Flower Vessel",
        label: "Porcelain Flower Vessel · Inquiry",
        category: "Porcelain · 瓷器",
        price: "Inquiry",
        material: "Handmade porcelain, mineral glaze",
        maker: "Maker, kiln or studio note is confirmed during inquiry.",
        use: "Flower display, sideboard display, gift collecting",
        leadTime: "If made to order, expected craft lead time is usually 10-30 days before dispatch.",
        package: "Reinforced box, soft wrap, English note card",
        ship: "Fragile pieces are quoted after destination confirmation.",
        desc: "A restrained porcelain vessel for branches, single flowers or quiet interior display."
      }
    ]
  },
  scent: {
    eyebrow: "Incense · 香器",
    title: "Incense Objects for Evening Rooms",
    copy: "Vessels, holders and agarwood pairings for meditative interiors and giftable scent rituals.",
    products: [
      {
        name: "Incense Vessel & Agarwood Set",
        label: "Incense Vessel & Agarwood Set · $128",
        category: "Incense · 香器",
        price: "$128",
        material: "Incense vessel, incense holder, agarwood pairing, ritual note card",
        use: "Evening room ritual, meditation, gift set composition",
        package: "Divided insert, sealed incense material pouch, English use card",
        ship: "Cross-border rules for incense materials are confirmed by destination before shipment.",
        desc: "A compact incense set for introducing overseas buyers to Eastern scent rituals."
      },
      {
        name: "Night Incense Holder",
        label: "Night Incense Holder · $86",
        category: "Incense · 香器",
        price: "$86",
        material: "Ceramic or metal holder, incense note card",
        use: "Desk ritual, bedside ritual, gift add-on",
        package: "Small gift box with protective wrap",
        ship: "Ships by tracked parcel after destination confirmation.",
        desc: "A small incense object for making a room feel intentional after dark."
      }
    ]
  },
  scholar: {
    eyebrow: "Scholar Objects · 文房",
    title: "Objects for the Study",
    copy: "Paper, seals, weights and desk objects for collectors who want a quiet intellectual atmosphere.",
    products: [
      {
        name: "Seal & Paper Gift Pairing",
        label: "Seal & Paper Gift Pairing · $118",
        category: "Scholar Objects · 文房",
        price: "$118",
        material: "Paper goods, seal object, note card",
        use: "Desk styling, cultural gifting, study display",
        package: "Flat gift box, paper sleeve, English cultural note",
        ship: "Paper goods ship with rigid protection.",
        desc: "A refined desk pairing for buyers interested in Chinese scholar culture."
      },
      {
        name: "Stone Paperweight",
        label: "Stone Paperweight · Inquiry",
        category: "Scholar Objects · 文房",
        price: "Inquiry",
        material: "Natural stone or carved material",
        use: "Desk display, paperweight, collector object",
        package: "Protective wrap and small collector box",
        ship: "Freight is confirmed by weight and destination.",
        desc: "A functional desk object with the presence of a small collectible."
      }
    ]
  },
  adornment: {
    eyebrow: "Adornment · 珠宝佩饰",
    title: "Subtle Jewelry and Personal Objects",
    copy: "Jade tones, silver fittings and wearable cultural objects with restrained daily elegance.",
    products: [
      {
        name: "Jade-Tone Silver Pendant",
        label: "Jade-Tone Silver Pendant · $236",
        category: "Jewelry · 珠宝佩饰",
        price: "$236",
        material: "Jade-tone material, silver fittings, hand-polished finish",
        use: "Daily wear, gifting, Eastern pattern collecting",
        package: "Jewelry box, polishing cloth, material note card",
        ship: "Jewelry can usually ship by tracked small parcel.",
        desc: "An Eastern adornment expressed through jade tones and silver fittings, emphasizing material and silhouette over loud gemstones."
      },
      {
        name: "Quiet Bracelet Object",
        label: "Quiet Bracelet Object · Inquiry",
        category: "Adornment · 珠宝佩饰",
        price: "Inquiry",
        material: "Beads, cord, metal or jade-tone details",
        use: "Daily wear, gifting, personal ritual",
        package: "Jewelry box and soft pouch",
        ship: "Tracked small parcel after confirmation.",
        desc: "A restrained wearable object for buyers who want cultural texture without excess."
      }
    ]
  },
  stone: {
    eyebrow: "Viewing Stones · 奇石",
    title: "Viewing Stones for Slow Interiors",
    copy: "Natural stones and wood stands selected for texture, silhouette and display value.",
    products: [
      {
        name: "Scholar Stone with Wood Stand",
        label: "Scholar Stone with Wood Stand · Inquiry",
        category: "Viewing Stone · 奇石",
        price: "Inquiry",
        material: "Natural viewing stone, custom wood stand, collector note card",
        use: "Study display, gallery-style collecting, interior styling",
        package: "Separated stand protection, reinforced outer box, one-of-one archive card",
        ship: "Shipping and insurance are confirmed by stone weight and destination.",
        desc: "A stone, a stand and a note card: a complete collecting path built around natural texture and interior display value."
      },
      {
        name: "Small Desk Viewing Stone",
        label: "Small Desk Viewing Stone · Inquiry",
        category: "Viewing Stone · 奇石",
        price: "Inquiry",
        material: "Natural stone, optional wood base",
        use: "Desk display, shelf display, collector gift",
        package: "Reinforced box and archive note",
        ship: "Quoted by weight, size and destination.",
        desc: "A smaller viewing stone suited to bookshelves, desks and intimate interior display."
      }
    ]
  },
  furniture: {
    eyebrow: "Woodwork & Display · 木器陈列",
    title: "Woodwork for Holding Objects",
    copy: "Stands, bases and small wood objects that give porcelain, stones and ritual pieces a stage.",
    products: [
      {
        name: "Hand-Carved Zhong Kui Pendant",
        label: "Hand-Carved Zhong Kui Pendant · $199",
        category: "Woodwork · 木器",
        price: "$199",
        material: "Thunderstruck wood, hand carving, braided cord, metal fittings, amber-tone beads",
        maker: "Hand-carved woodwork. Artisan / studio profile is shared when available.",
        use: "Wearable pendant, car hanging, study display, gift collecting",
        leadTime: "Ready piece after condition check; similar custom wood carving may require 10-30 days.",
        package: "Black collector gift box, soft pouch, English cultural note card",
        ship: "Small wood objects can ship by tracked international parcel. Destination restrictions are confirmed before shipment.",
        desc: "A hand-carved Zhong Kui figure in dark thunderstruck wood, preserving natural grain, knife marks and a deep polished surface."
      },
      {
        name: "Custom Wood Display Stand",
        label: "Custom Wood Display Stand · Inquiry",
        category: "Woodwork & Display · 木器陈列",
        price: "Inquiry",
        material: "Wood stand, hand-finished surface",
        maker: "Woodworker profile and workshop note are confirmed before payment.",
        use: "Stone support, porcelain display, desk arrangement",
        leadTime: "Made-to-order display stands usually require 10-30 days depending on size and finish.",
        package: "Protected wrap and rigid outer box",
        ship: "Freight depends on size and destination.",
        desc: "A quiet support object designed to frame a stone, vessel or small collectible."
      }
    ]
  },
  gift: {
    eyebrow: "Gift Sets · 礼盒",
    title: "Composed Gifts by Occasion",
    copy: "Advisory sets built by recipient, budget and mood, then confirmed by stock and shipping limits.",
    products: [
      {
        name: "Tea Table Gift Direction",
        label: "Tea Table Gift Direction · $150-$250",
        category: "Gift Sets · 礼盒",
        price: "$150-$250",
        material: "Porcelain, paper note, optional incense object",
        use: "Birthday gift, host gift, collector introduction",
        package: "Gift box, tissue, cultural note card",
        ship: "Final combination and shipping are confirmed before payment.",
        desc: "A composed direction for a recipient who appreciates tea, quiet interiors and handmade materials."
      },
      {
        name: "Collector Gift Direction",
        label: "Collector Gift Direction · $250+",
        category: "Gift Sets · 礼盒",
        price: "$250+",
        material: "One main object plus supporting note or display element",
        use: "VIP gifting, collector introduction, interior gift",
        package: "Collector presentation with English context card",
        ship: "Quoted after object selection and destination confirmation.",
        desc: "A more considered gift path built around one object of weight."
      }
    ]
  }
};

const updateMusicButton = (state) => {
  musicToggle.classList.remove("is-loading", "is-muted", "is-blocked");
  if (state) musicToggle.classList.add(state);
  const isPlaying = !siteMusic.paused && musicAllowed;
  musicToggle.setAttribute("aria-pressed", String(isPlaying));
  musicToggle.setAttribute("aria-label", isPlaying ? "Turn off background sound" : "Turn on background sound");
  musicToggle.querySelector("strong").textContent =
    state === "is-blocked" ? "Sound" : isPlaying ? "Sound On" : "Sound Off";
};

const startMusic = async () => {
  siteMusic.volume = 0.5;
  if (!musicAllowed) {
    siteMusic.pause();
    updateMusicButton("is-muted");
    return;
  }
  try {
    await siteMusic.play();
    updateMusicButton();
  } catch (error) {
    updateMusicButton("is-blocked");
  }
};

const startMusicFromGesture = () => {
  if (!musicAllowed || !siteMusic.paused) return;
  startMusic();
};

const bindMusicGesture = () => {
  if (musicGestureBound) return;
  musicGestureBound = true;
  ["pointerdown", "touchstart", "keydown"].forEach((eventName) => {
    window.addEventListener(eventName, startMusicFromGesture, { passive: true, once: true });
  });
};

messageField?.addEventListener("input", () => {
  messageField.dataset.autoFilled = "false";
});

const hidePrologue = (target) => {
  prologue.classList.add("is-hidden");
  document.body.classList.remove("has-prologue");
  sessionStorage.setItem("yunjianPrologueSeen", "true");
  if (target) {
    window.setTimeout(() => {
      document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }, 520);
  }
};

const showPrologue = () => {
  prologue.classList.remove("is-hidden");
  document.body.classList.add("has-prologue");
};

const forcePrologue = new URLSearchParams(window.location.search).get("prologue") === "1";

if (forcePrologue) {
  sessionStorage.removeItem("yunjianPrologueSeen");
}

if (!forcePrologue && sessionStorage.getItem("yunjianPrologueSeen") === "true") {
  prologue.classList.add("is-hidden");
} else {
  document.body.classList.add("has-prologue");
}

startMusic();
bindMusicGesture();

const showToast = (message) => {
  toast.textContent = message;
  toast.classList.add("is-visible");
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => {
    toast.classList.remove("is-visible");
  }, 2200);
};

const syncCounts = () => {
  const count = listState.size;
  listCount.textContent = String(count);
  mobileListCount.textContent = String(count);
  emptyList.classList.toggle("is-hidden", count > 0);
};

const renderList = () => {
  selectedItems.innerHTML = "";
  listState.forEach((item) => {
    const li = document.createElement("li");
    li.innerHTML = `<span>${item}</span><button type="button" aria-label="Remove ${item}">Remove</button>`;
    li.querySelector("button").addEventListener("click", () => {
      listState.delete(item);
      renderList();
      syncCounts();
      showToast(`Removed: ${item}`);
    });
    selectedItems.append(li);
  });
  syncCounts();
  if (messageField && listState.size > 0) {
    const items = Array.from(listState.keys()).join(" / ");
    if (!messageField.value || messageField.dataset.autoFilled === "true") {
      messageField.value = `Inquiry list: ${items}`;
      messageField.dataset.autoFilled = "true";
    }
  }
};

const addToList = (item) => {
  if (!item) return;
  const existed = listState.has(item);
  listState.set(item, item);
  renderList();
  showToast(existed ? `Already in inquiry list: ${item}` : `Added to inquiry list: ${item}`);
};

const syncChrome = () => {
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  const progressWidth = maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0;
  header.classList.toggle("is-scrolled", window.scrollY > 24);
  backToTop.classList.toggle("is-visible", window.scrollY > 760);
  progress.style.width = `${progressWidth}%`;
  if (heroImage) {
    heroImage.style.setProperty("--hero-y", `${window.scrollY * 0.08}px`);
  }
};

window.addEventListener("scroll", syncChrome, { passive: true });
syncChrome();

menuToggle.addEventListener("click", () => {
  const isOpen = header.classList.toggle("nav-open");
  menuToggle.setAttribute("aria-expanded", String(isOpen));
});

document.querySelectorAll(".nav-links a").forEach((link) => {
  link.addEventListener("click", () => {
    header.classList.remove("nav-open");
    menuToggle.setAttribute("aria-expanded", "false");
  });
});

document.querySelectorAll("[data-enter-site]").forEach((button) => {
  button.addEventListener("click", () => {
    startMusicFromGesture();
    hidePrologue();
  });
});

document.querySelector("[data-enter-gift]").addEventListener("click", () => {
  startMusicFromGesture();
  hidePrologue("#gift");
});

replayPrologue.addEventListener("click", showPrologue);

musicToggle.addEventListener("click", async () => {
  if (siteMusic.paused || !musicAllowed) {
    musicAllowed = true;
    localStorage.setItem("yunjianMusicMuted", "false");
    await startMusic();
    showToast("Sound on");
  } else {
    musicAllowed = false;
    localStorage.setItem("yunjianMusicMuted", "true");
    siteMusic.pause();
    updateMusicButton("is-muted");
    showToast("Sound off");
  }
});

document.querySelectorAll("[data-product]").forEach((button) => {
  button.addEventListener("click", () => {
    const item = button.dataset.product;
    addToList(item);
    if (button.matches(".product-actions button:first-child")) {
      button.textContent = "Added";
      button.disabled = true;
    }
  });
});

const openDetail = (button) => {
  activeDetail = button.dataset.detail;
  document.querySelector("#drawerCategory").textContent = button.dataset.categoryLabel;
  document.querySelector("#drawerTitle").textContent = button.dataset.detail;
  document.querySelector("#drawerPrice").textContent = button.dataset.price;
  document.querySelector("#drawerDesc").textContent = button.dataset.desc;
  document.querySelector("#drawerMaterial").textContent = button.dataset.material || "Material notes are confirmed after inquiry.";
  document.querySelector("#drawerMaker").textContent = button.dataset.maker || "Maker profile is confirmed when available.";
  document.querySelector("#drawerUse").textContent = button.dataset.use || "Overseas gifting, personal collecting, interior display";
  document.querySelector("#drawerLeadTime").textContent = button.dataset.leadTime || "Ready pieces are confirmed before payment; made-to-order craft pieces usually require 10-30 days.";
  document.querySelector("#drawerPackage").textContent = button.dataset.package || "Gift and shipping protection are confirmed before dispatch.";
  document.querySelector("#drawerShip").textContent = button.dataset.ship || "Stock, packaging and international shipping are confirmed after inquiry.";
  detailDrawer.classList.add("is-open");
  detailDrawer.setAttribute("aria-hidden", "false");
};

document.addEventListener("click", (event) => {
  const detailButton = event.target.closest("[data-detail]");
  if (!detailButton) return;
  openDetail(detailButton);
});

document.querySelector(".drawer-add").addEventListener("click", () => {
  addToList(activeDetail);
  detailDrawer.classList.remove("is-open");
  detailDrawer.setAttribute("aria-hidden", "true");
});

document.querySelector(".drawer-close").addEventListener("click", () => {
  detailDrawer.classList.remove("is-open");
  detailDrawer.setAttribute("aria-hidden", "true");
});

detailDrawer.addEventListener("click", (event) => {
  if (event.target === detailDrawer) {
    detailDrawer.classList.remove("is-open");
    detailDrawer.setAttribute("aria-hidden", "true");
  }
});

const openList = () => {
  listDrawer.classList.add("is-open");
  listDrawer.setAttribute("aria-hidden", "false");
};

document.querySelector(".floating-list").addEventListener("click", openList);
document.querySelector("[data-open-list]").addEventListener("click", openList);

document.querySelector(".list-close").addEventListener("click", () => {
  listDrawer.classList.remove("is-open");
  listDrawer.setAttribute("aria-hidden", "true");
});

listDrawer.addEventListener("click", (event) => {
  if (event.target === listDrawer) {
    listDrawer.classList.remove("is-open");
    listDrawer.setAttribute("aria-hidden", "true");
  }
});

document.querySelectorAll("[data-filter]").forEach((button) => {
  button.addEventListener("click", () => {
    const filter = button.dataset.filter;
    document.querySelectorAll("[data-filter]").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
    document.querySelectorAll("[data-category-card]").forEach((card) => {
      const active = card.dataset.categoryCard === filter;
      card.classList.toggle("is-dimmed", !active);
    });
  });
});

const productButtonMarkup = (product) => `
  <button
    type="button"
    data-detail="${product.name}"
    data-category-label="${product.category}"
    data-price="${product.price}"
    data-material="${product.material}"
    data-maker="${product.maker || "Maker profile is confirmed when available."}"
    data-use="${product.use}"
    data-lead-time="${product.leadTime || "Ready pieces are confirmed before payment; made-to-order craft pieces usually require 10-30 days."}"
    data-package="${product.package}"
    data-ship="${product.ship}"
    data-desc="${product.desc}"
  >${product.label}</button>
`;

const openCollection = (key, options = {}) => {
  const data = collectionData[key] || collectionData.porcelain;
  collectionEyebrow.textContent = data.eyebrow;
  collectionTitle.textContent = data.title;
  collectionCopy.textContent = data.copy;
  collectionProducts.innerHTML = data.products.map(productButtonMarkup).join("");
  document.querySelectorAll("[data-filter]").forEach((button) => {
    button.classList.toggle("is-active", button.dataset.filter === key);
  });
  document.querySelectorAll("[data-open-collection]").forEach((target) => {
    target.classList.toggle("is-active", target.dataset.openCollection === key);
  });
  document.querySelectorAll("[data-category-card]").forEach((card) => {
    const active = card.dataset.categoryCard === key;
    card.classList.toggle("is-selected", active);
    card.classList.toggle("is-dimmed", !active);
  });
  collectionPanel.classList.add("is-focused");
  collectionPanel.classList.remove("is-updating");
  requestAnimationFrame(() => collectionPanel.classList.add("is-updating"));
  if (!options.silent) {
    collectionPanel.scrollIntoView({ behavior: "smooth", block: "nearest" });
    showToast(`Viewing: ${data.title}`);
  }
};

document.addEventListener("click", (event) => {
  const target = event.target.closest("[data-open-collection]");
  if (!target) return;
  openCollection(target.dataset.openCollection);
});

document.querySelectorAll("[data-open-collection]").forEach((target) => {
  target.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    openCollection(target.dataset.openCollection);
  });
});

openCollection("porcelain", { silent: true });

document.querySelectorAll("[data-gift-choice]").forEach((button) => {
  button.addEventListener("click", () => {
    const group = button.dataset.giftChoice;
    document.querySelectorAll(`[data-gift-choice="${group}"]`).forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
    giftChoices.set(group, button.dataset.set);
    const summary = Array.from(giftChoices.entries())
      .map(([key, value]) => `${key}: ${value}`)
      .join(" / ");
    selectedSet.textContent = summary || "Not selected yet";
    if (messageField) {
      const giftLine = `Gift direction: ${summary}`;
      if (!messageField.value || messageField.dataset.autoFilled === "true") {
        messageField.value = giftLine;
        messageField.dataset.autoFilled = "true";
      } else if (!messageField.value.includes("Gift direction:")) {
        messageField.value = `${messageField.value}\n${giftLine}`;
      }
    }
    showToast(`Gift direction updated: ${button.dataset.set}`);
  });
});

signupForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const formData = new FormData(signupForm);
  const email = formData.get("email");
  const country = formData.get("country");
  const items = Array.from(listState.keys());
  formNote.textContent = email
    ? `Thank you${country ? `. Destination: ${country}` : ""}${items.length ? `. List: ${items.join(", ")}` : ""}. We will reply with availability, freight and the secure payment step after confirmation.`
    : "Please enter your email address.";
  showToast(email ? "Inquiry ready" : "Please enter your email address");
  if (email) {
    signupForm.reset();
    if (messageField) messageField.dataset.autoFilled = "false";
  }
});

backToTop.addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

const ensureOwnerPicksFallback = () => {
  if (document.querySelector(".curator-card")) return;
  const section = document.querySelector("#collections.commerce-section");
  if (!section) return;

  const assetBase = `${window.location.origin}/cdn/shop/t/3/assets/`;
  const esc = (value = "") =>
    String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  const picks = [
    {
      image: "zhongkui-card.png",
      category: "Woodwork · 木器",
      title: "Hand-Carved Zhong Kui Pendant",
      price: "$199",
      copy: "Compact, story-rich and giftable: the clearest entry point into Chinese folk carving.",
      material: "Thunderstruck wood, hand carving, braided cord, metal fittings, amber-tone beads",
      maker: "Hand-carved woodwork. Artisan / studio profile is shared when available.",
      use: "Wearable pendant, car hanging, study display, gift collecting",
      leadTime: "Ready piece after condition check; similar custom wood carving may require 10-30 days.",
      package: "Black collector gift box, soft pouch, English cultural note card",
      ship: "Ships from Hangzhou, China by tracked international parcel after destination confirmation.",
      desc: "A hand-carved Zhong Kui figure in dark thunderstruck wood, preserving natural grain, knife marks and a deep polished surface."
    },
    {
      image: "category-porcelain.png",
      category: "Porcelain · 瓷器",
      title: "Celadon Teacup Gift Set",
      price: "$168",
      copy: "A gentle first purchase for tea lovers, host gifts and quiet daily ritual.",
      material: "Handmade celadon, mineral glaze, collector note card",
      use: "Tea table gifting, first collectible, study display",
      package: "Rigid gift box, protective insert, English material card",
      ship: "Fragile pieces receive reinforced packaging before dispatch.",
      desc: "A handmade celadon teacup with a collector card, designed as an accessible first piece for overseas gifting."
    },
    {
      image: "category-scent.png",
      category: "Incense · 香器",
      title: "Incense Vessel & Agarwood Set",
      price: "$128",
      copy: "Easy to understand, easy to gift, and strong for evening room atmosphere.",
      material: "Incense vessel, incense holder, agarwood pairing, ritual note card",
      use: "Evening room ritual, meditation, gift set composition",
      package: "Divided insert, sealed incense material pouch, English use card",
      ship: "Destination rules for incense materials are confirmed before shipment.",
      desc: "A compact incense set for introducing overseas buyers to Eastern scent rituals."
    },
    {
      image: "category-jewelry.png",
      category: "Adornment · 珠宝佩饰",
      title: "Jade-Tone Silver Pendant",
      price: "$236",
      copy: "A wearable object for buyers who prefer restrained material detail over loud jewelry.",
      material: "Jade-tone material, silver fittings, hand-polished finish",
      use: "Daily wear, gifting, Eastern pattern collecting",
      package: "Jewelry box, polishing cloth, material note card",
      ship: "Tracked small parcel after confirmation.",
      desc: "An Eastern adornment expressed through jade tones and silver fittings, emphasizing material and silhouette over loud gemstones."
    },
    {
      image: "category-stone.png",
      category: "Viewing Stone · 奇石",
      title: "Scholar Stone with Wood Stand",
      price: "Inquiry",
      copy: "Best for collectors, shelves and study rooms where texture matters more than decoration.",
      material: "Natural viewing stone, custom wood stand, collector note card",
      use: "Study display, gallery-style collecting, interior styling",
      package: "Separated stand protection, reinforced outer box, one-of-one archive card",
      ship: "Shipping and insurance are confirmed by stone weight and destination.",
      desc: "A stone, a stand and a note card: a complete collecting path built around natural texture and interior display value."
    },
    {
      image: "category-scholar.png",
      category: "Scholar Objects · 文房",
      title: "Seal & Paper Gift Pairing",
      price: "$118",
      copy: "A lighter cultural gift for desks, stationery lovers and first-time buyers.",
      material: "Paper goods, seal object, note card",
      use: "Desk styling, cultural gifting, study display",
      package: "Flat gift box, paper sleeve, English cultural note",
      ship: "Paper goods ship with rigid protection.",
      desc: "A refined desk pairing for buyers interested in Chinese scholar culture."
    },
    {
      image: "category-gift.png",
      category: "Gift Sets · 礼盒",
      title: "Tea Table Gift Direction",
      price: "$150-$250",
      copy: "A composed route when the buyer knows the recipient but not the exact object.",
      material: "Porcelain, paper note, optional incense object",
      use: "Birthday gift, host gift, collector introduction",
      package: "Gift box, tissue, cultural note card",
      ship: "Final combination and shipping are confirmed before payment.",
      desc: "A composed direction for a recipient who appreciates tea, quiet interiors and handmade materials."
    },
    {
      image: "category-furniture.png",
      category: "Woodwork & Display · 木器陈列",
      title: "Custom Wood Display Stand",
      price: "Inquiry",
      copy: "A practical support piece for stones, porcelain and small collectibles.",
      material: "Wood stand, hand-finished surface",
      maker: "Woodworker profile and workshop note are confirmed before payment.",
      use: "Stone support, porcelain display, desk arrangement",
      leadTime: "Made-to-order display stands usually require 10-30 days depending on size and finish.",
      package: "Protected wrap and rigid outer box",
      ship: "Freight depends on size and destination.",
      desc: "A quiet support object designed to frame a stone, vessel or small collectible."
    }
  ];

  const cardMarkup = (item, index) => `
    <article class="curator-card${index === 0 ? " curator-card-large" : ""}">
      <div class="curator-media"><img src="${assetBase}${item.image}" alt="${esc(item.title)}" loading="lazy"></div>
      <div class="curator-body">
        <p>${item.category}</p>
        <h3>${item.title}</h3>
        <span>${item.price}</span>
        <small>${item.copy}</small>
        <div class="curator-actions">
          <button type="button" data-product="${esc(item.title)}">${item.price === "Inquiry" ? "Add to Inquiry" : "Add"}</button>
          <button class="ghost-action" type="button" data-detail="${esc(item.title)}" data-category-label="${esc(item.category)}" data-price="${esc(item.price)}" data-material="${esc(item.material)}" data-maker="${esc(item.maker || "Maker profile is confirmed when available.")}" data-use="${esc(item.use)}" data-lead-time="${esc(item.leadTime || "Ready pieces are confirmed before payment; made-to-order craft pieces usually require 10-30 days.")}" data-package="${esc(item.package)}" data-ship="${esc(item.ship)}" data-desc="${esc(item.desc)}">Details</button>
        </div>
      </div>
    </article>`;

  section.innerHTML = `
    <div class="commerce-heading reveal is-visible">
      <div>
        <p class="eyebrow">Owner's Picks · 店主推荐</p>
        <h2>A short edit of recommended objects before the full catalog.</h2>
      </div>
      <p>Eight or fewer pieces, selected to show the range of the store without overwhelming the buyer: giftable, collectible, easy to understand, and ready for inquiry.</p>
    </div>
    <div class="curator-grid reveal is-visible" aria-label="Owner recommended products">
      ${picks.map(cardMarkup).join("")}
    </div>`;
  section.querySelectorAll("[data-product]").forEach((button) => {
    button.addEventListener("click", () => addToList(button.dataset.product));
  });

  if (!document.querySelector("#ownerPicksFallbackStyle")) {
    const style = document.createElement("style");
    style.id = "ownerPicksFallbackStyle";
    style.textContent = `
      .curator-grid{display:grid;grid-template-columns:1.08fr 1fr 1fr;gap:1px;border:1px solid rgba(21,19,15,.16);background:rgba(21,19,15,.16)}
      .curator-card{display:grid;min-height:430px;background:#fffaf4;overflow:hidden;transition:transform .22s ease,box-shadow .22s ease,background .22s ease}
      .curator-card-large{grid-row:span 2}
      .curator-card:hover{z-index:2;background:#fffdf8;box-shadow:0 28px 80px rgba(21,13,8,.18);transform:translateY(-3px)}
      .curator-media{min-height:210px;overflow:hidden;background:#e6d8c2}
      .curator-card-large .curator-media{min-height:420px}
      .curator-media img{width:100%;height:100%;object-fit:cover;display:block;filter:saturate(.94) contrast(1.04);transition:transform .7s ease,filter .7s ease}
      .curator-card:hover .curator-media img{filter:saturate(1.02) contrast(1.08);transform:scale(1.055)}
      .curator-body{display:grid;align-content:start;padding:24px}
      .curator-body p{margin:0 0 12px;color:#783429;font-family:Arial,PingFang SC,Microsoft YaHei,sans-serif;font-size:12px;font-weight:700}
      .curator-body h3{margin:0 0 12px;font-size:clamp(22px,2vw,32px);line-height:1.12}
      .curator-body span{display:block;margin-bottom:14px;color:#4f695e;font-size:19px}
      .curator-body small{display:block;min-height:58px;color:#675e4f;font-family:Arial,PingFang SC,Microsoft YaHei,sans-serif;font-size:13px;line-height:1.62}
      .curator-actions{display:grid;grid-template-columns:1fr auto;gap:8px;margin-top:20px}
      .curator-actions button{min-height:44px;border:1px solid rgba(21,19,15,.16);background:#15130f;color:#fff8ed;padding:0 16px;cursor:pointer;font-family:Arial,PingFang SC,Microsoft YaHei,sans-serif;font-size:12px;font-weight:700}
      .curator-actions .ghost-action{background:transparent;color:#15130f}
      @media(max-width:900px){.curator-grid{grid-template-columns:repeat(2,minmax(0,1fr))}.curator-card-large{grid-row:auto}.curator-card-large .curator-media{min-height:260px}}
      @media(max-width:560px){.curator-grid{grid-template-columns:1fr}.curator-card{min-height:auto}.curator-media,.curator-card-large .curator-media{min-height:230px}.curator-actions{grid-template-columns:1fr}.curator-actions button{width:100%}}
    `;
    document.head.append(style);
  }
};

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    hidePrologue();
    detailDrawer.classList.remove("is-open");
    listDrawer.classList.remove("is-open");
    detailDrawer.setAttribute("aria-hidden", "true");
    listDrawer.setAttribute("aria-hidden", "true");
  }
});

ensureOwnerPicksFallback();

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.16 }
);

document.querySelectorAll(".reveal").forEach((element) => {
  revealObserver.observe(element);
});

renderList();
